import React from 'react';

import Button from '../../ui/Button';
import TextField from '../../ui/TextField';

const fields = [
  {
    key: 'firstName',
    type: 'text',
    label: 'First Name',
  },
  {
    key: 'lastName',
    type: 'text',
    label: 'Last Name',
  },
  {
    key: 'email',
    type: 'text',
    label: 'Email Address',
  },
];

const styleField = {
  marginBottom: 16,
};

const styleButton = {
  height: 48,
  width: '100%',
};

class UserRegisterForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
    };

    this.handleChange = {};

    this.setValue = (key, value) => this.setState(prevState => ({
      values: {
        ...prevState.values,
        [key]: value,
      },
    }));

    fields.forEach((field) => {
      this.state.values[field.key] = '';
      this.handleChange[field.key] = (e) => this.setValue(field.key, e.target.value);
    });
  }

  handleSubmit = (e) => {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.values);
    }
  };

  renderTextField = (field) => (
    <TextField
      {...field}
      onChange={this.handleChange[field.key]}
      value={this.state.values[field.key]}
    />
  );

  renderFieldByType = (field) => {
    switch (field.type) {
      case 'text':
      default:
        return this.renderTextField(field);
    }
  };

  renderField = (field) => (
    <div style={styleField} key={field.key}>
      {this.renderFieldByType(field)}
    </div>
  );

  renderFields() {
    return fields.map(this.renderField);
  }

  render() {
    return (
      <div>
        <div>{this.renderFields()}</div>
        <div>
          <Button
            color="accent"
            label="Register"
            isRaised
            onClick={this.handleSubmit}
            style={styleButton}
          />
        </div>
      </div>
    );
  }
}


export default UserRegisterForm;



// WEBPACK FOOTER //
// ./src/components/features/UserRegisterForm/UserRegisterForm.js